<template>
  <div id="footer" class="fixed-footer" :class="{ 'speak-sheet-show': speakShow, 'top-show': topShow }" v-if="show && showChat">
    <div class="left-ipt">
      <div v-if="showChat" @click="clickChat">说点什么...</div>
    </div>

    <div class="icon-box">
      <!-- <ft-icon
        icon="icon-gouwuche"
        v-if="getByRefurbishName('bringGoods').refurbishFlg === '0'"
        class="commodity"
        @click="linkTo(getByRefurbishName('bringGoods').refurbishJson.link)"
      ></ft-icon> -->
      <!-- tag="123" -->
      <!-- <ft-icon icon="icon-songli" @click="giftshow = true" />-->
      <!-- <ft-icon v-if="getByRefurbishName('share').refurbishFlg === '0'" @click="toShare" icon="icon-fenxiang" />-->
      <!-- <div
        v-if="isJa && getByRefurbishName('like').refurbishFlg === '0'"
        @click="addPraise"
        class="give-like-icon"
        :class="{ 'praise-icon': praiseCount && showCount }"
      >
        <img class="icon-praise" src="@/assets/images/ja/praise2.png" alt="" srcset="" />
        <give-like class="give-like" ref="piao" />
        <span v-if="praiseCount && showCount" class="badge">{{ calcPraiseCount }}</span>
      </div> -->
    </div>
    <speak-sheet @click="send" v-model="speakShow" :words="commonWord" :showWord="showWord" />
    <!-- <van-action-sheet v-model="productshow">
      <product-list />
    </van-action-sheet> -->
    <van-action-sheet v-model="giftshow" title="赠送一个小礼物吧">
      <gift-box />
    </van-action-sheet>
  </div>
</template>
<script>
import GiftBox from './GiftBox';
// import ProductList from './ProductList';
import { openAppAndLoginInterceptor, needOpenApp, isRmtEnv, getRoomShareViewAuth } from '@/core/index';
export default {
  name: 'Footer',
  data() {
    return {
      room: $$.module.data.room,
      giftshow: false,
      productshow: false,
      speakShow: false,
      disabledRelease: true,
      praiseCount: 0,
      api: $$.module.interview.$api,
      // likeActive: false,
      sendConfig: {
        chat: this.sendChat,
        quest: this.sendQuest
      },
      shop: {},
      // isRmtEnv: null,
      commonWord: [],
      commonWordTimer: null,

      topShow: false,
      topShowTimer: null
    };
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    chatType: {
      type: String,
      default: ''
    },
    like: {
      type: Boolean,
      default: false
    },
    showWord: {
      type: Boolean,
      default: true
    }
  },
  components: {
    GiftBox
    // ProductList
  },
  mounted() {
    this.likeActive = this.like;
    this.praiseCount = this.room.roomCount?.praiseCount;
  },
  watch: {
    showWord: {
      handler() {
        if (this.showWord) {
          this.getCommonWord();
          if (this.commonWordTimer) {
            clearInterval(this.commonWordTimer);
            this.commonWordTimer = null;
          }
          this.commonWordTimer = setInterval(() => {
            this.getCommonWord();
          }, 15000);
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.commonWordTimer);
  },
  computed: {
    showChat() {
      return this.getByRefurbishName('chat').refurbishFlg === '0' && (isRmtEnv() || needOpenApp() || getRoomShareViewAuth().enableLogin);
    },
    // 人气值是否开启
    showCount() {
      return this.getByRefurbishName('peopleNumber').refurbishFlg === '0';
    },
    isJa() {
      return this.siteId == 310106;
    },
    siteId() {
      return $$.module.data.room.siteId;
    },
    calcPraiseCount() {
      let val = this.praiseCount;
      val ||= 0;
      if (val < 10000) {
        return val;
      }
      let v = Number(val / 10000);
      if (v < 10) {
        return parseInt(v * 10) / 10 + '万';
      } else {
        return parseInt(v) + '万';
      }
    }
  },
  methods: {
    clickChat() {
      openAppAndLoginInterceptor(() => {
        this.speakShow = true;
      });
    },
    getByRefurbishName(name) {
      return this.room.roomRefurbish.find((data) => data.refurbishName === name);
    },
    linkTo(val) {
      window.location.href = val;
    },
    send(val) {
      if (!this.chatType || !val) return;
      const fun = this.sendConfig[this.chatType];
      fun && fun(val);
    },
    getCommonWord() {
      this.api.commonWords({
        data: {
          pageNo: 1,
          pageSize: 100,
          roomId: $$.module.data.room.roomId
        },
        success: (res) => {
          res?.records?.length && (this.commonWord = res.records);
        }
      });
    },
    // addPraise() {
    //   // if(this.likeActive)  return
    //   this.api.addPraise({
    //     data: {
    //       roomId: $$.module.data.room.roomId,
    //       roomType: '1'
    //     },
    //     success: () => {
    //       this.likeActive = true;
    //     }
    //   });
    // },
    // 点赞
    addPraise() {
      openAppAndLoginInterceptor(() => {
        this.topShow = true;
        if (this.topShowTimer) {
          clearTimeout(this.topShowTimer);
          this.topShowTimer = null;
        }
        this.topShowTimer = setTimeout(() => {
          this.topShow = false;
        }, 1200);
        this.api.addPraise({
          data: {
            roomId: $$.module.data.room.roomId,
            roomType: '1'
          },
          success: () => {
            this.likeActive = true;
            this.praiseCount++;
          }
        });
      });
    },
    isCommonWord(val) {
      return this.commonWord.find((v) => v.commonWord === val);
    },
    sendChat(val) {
      if ($$.module.data.room.chatSettingContent.chatStatus === '2') {
        this.$toast('您已被禁言');
        this.close();
        return;
      }
      const isCommonWord = this.isCommonWord(val);
      // 用户发送的是 常用语， （常用语单独接口 -> 嘉定常用语抽奖需求）
      if (isCommonWord) {
        this.api.sendMemberCommonWordMsg({
          data: {
            roomId: $$.module.data.room.roomId,
            commonWordId: isCommonWord.id
          },
          success: () => {},
          execption: () => {
            this.$toast.fail('发送失败');
          }
        });
      } else {
        this.api
          .sendChat({
            data: {
              roomId: $$.module.data.room.roomId,
              text: val
            },
            success: () => {},
            execption: () => {
              this.$toast.fail('发送失败');
            }
          })
          .then((result) => {
            if (result.msg && result.msg.indexOf('审核') > -1) {
              this.$toast('审核中');
              $$.module.data.room.chatSettingContent.chatStyle = '1';
            } else {
              $$.module.data.room.chatSettingContent.chatStyle = '2';
            }
          });
      }

      this.close();
    },
    sendQuest(val) {
      this.api.sendQuest({
        data: {
          roomId: $$.module.data.room.roomId,
          text: val
        },
        success: () => {},
        execption: () => {
          this.$toast.fail('发送失败');
        }
      });
      this.close();
    },
    close() {
      this.speakWord = '';
      this.speakShow = false;
    },
    change() {
      this.$emit('change', true);
    }
  }
  // destroyed() {
  //   this.$refs.piao && (this.$refs.piao.result = []);
  // }
};
</script>
<style lang="less">
.fixed-footer {
  padding: 8px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 299;
  background-color: #f2f2f2;
  padding-bottom: max(constant(safe-area-inset-bottom), 24px);
  padding-bottom: max(env(safe-area-inset-bottom), 24px);
  &.top-show {
    z-index: 9999;
  }
  &.speak-sheet-show {
    z-index: 40000;
  }
  .left-ipt {
    flex-grow: 1;
    padding-right: 16px;
    font-size: 14px;
    user-select: none;
    > div {
      width: 100%;
      border-radius: 24px;
      background: #fff;
      height: 42px;
      line-height: 42px;
      padding-left: 16px;
      color: #999;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.03);
    }
  }
  .icon-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-right: -12px;
    .icon {
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.03);
      &:not(:first-child) {
        margin-left: 12px;
      }
      .iconfont {
        font-size: 28px;
        color: #777;
        &.icon-gouwuche {
          color: #fff;
        }
      }
    }
  }

  .commodity {
    background: linear-gradient(90deg, rgba(234, 69, 12, 1) 0%, rgba(254, 136, 36, 1) 100%);
  }

  .bubble-card {
    width: 84vw;
    position: absolute;
    bottom: 88px;
    left: 50%;
    margin-left: -42vw;
    background: #fff;
    box-shadow: 0 6px 10px rgba(150, 150, 150, 0.15);
    .van-card {
      padding: 8px;
      z-index: 3;
    }
    .van-card__thumb {
      height: 76px;
      width: 76px;
      img {
        border-radius: 3px;
      }
    }
    .van-card__content {
      min-height: auto;
      padding: 4px;
      .van-card__title {
        line-height: 1.3;
        max-height: 42px;
      }
      .van-card__price * {
        color: #f00;
      }
      .icon {
        position: absolute;
        right: 12px;
        bottom: 0;
        border: 1px solid #f00;
        width: 36px;
        height: 36px;
      }
    }
    &:after {
      content: '';
      display: block;
      height: 0;
      width: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 16px solid #fff;
      position: absolute;
      left: 50%;
      margin-left: -8px;
      bottom: -12px;
    }
  }

  .fticon {
    width: 42px;
    height: 42px;
    .iconfont {
      font-size: 24px;
      color: #fff;
    }
  }
  .give-like-icon {
    position: relative;
    width: 42px;
    height: 42px;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon-praise {
      width: 32px;
      height: 32px;
    }
    &.praise-icon {
      margin-left: 12px;
    }
  }

  .give-like {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  .badge {
    position: absolute;
    display: inline-block;
    padding: 1px 5px;
    border-radius: 12px;
    border-bottom-right-radius: 0;
    background: #f34444;
    border: 1px solid #ffffff;
    color: #fff;
    right: 26px;
    top: 2px;
    font-size: 12px;
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
